<div class="flex text-left flex-column modal-cntr">

   <h1 class="mb-4">{{ config.AuctionName }}.</h1>

        <p>
            <strong>Prezzo di partenza dell'asta {{config.StartingPrice}}€.</strong>
        </p>

        <ng-container *ngIf="config.Address; else noAddressTmpl">

            <p> In caso di vittoria l'asta sarà recapitata all'indirizzo: <strong>{{config.Address}}</strong> </p>

        </ng-container>

        <ng-template #noAddressTmpl>

            <form [formGroup]="form">

                <p>Indirizzo a cui sarà recapitato il prodotto in caso di vittoria:</p>

                <div class="flex justify-content-center mb-4">

                    <p-floatLabel>
                        <p-multiSelect [style]="'width:100%'" [options]="address" optionLabel="label" [formControlName]="'Address'" [selectionLimit]="1"/>
                    </p-floatLabel>

                </div>

             </form>

        </ng-template>

        <ng-container *ngIf="config.Offer">

            <p>La tua ultima offerta per singolo lotto è di: <strong>{{config.Offer}}€</strong></p>

        </ng-container>


        <div class="bid-cntr mb-4">

            <pn-number-control [configuration]="offerInputConfiguration"></pn-number-control>

            <div class="button-bid" (click)="bid(2)">+2</div>
            <div class="button-bid" (click)="bid(5)">+5</div>
            <div class="button-bid" (click)="bid(10)">+10</div>

        </div>

        <h4 *ngIf="this.config.BidQuantity > 1" style="font-weight: bold"> {{this.generateSubtitle()}} </h4>

        <div class="modal-footer mt-5">

            <p-button label="Annulla" severity="danger" icon="pi pi-times" (click)="ref.close(false)"/>
            <p-button label="Conferma"severity="success"  icon="pi pi-check" (click)="onSubmit()"/>

        </div>

</div>

<p-toast></p-toast>
